import React from "react";
import { bool, array } from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Icon,
  IconButton,
} from "@mui/material";
import { formatCurrency } from "../../../utils/utils";

export const TablePartialInvoice = ({
  loading,
  partialInvoice,
  loadPrintAndShow,
}) => {
  return (
    <>
      {loading ? (
        <>
          <CircularProgress />
          <p>Cargando...</p>
        </>
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">No.</TableCell>
              <TableCell align="left">No. Partial</TableCell>
              <TableCell align="left">No. Fact</TableCell>
              <TableCell align="left">Titular</TableCell>
              <TableCell align="left">Monto</TableCell>
              <TableCell align="left">Fecha</TableCell>
              <TableCell align="left">Opción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {partialInvoice && partialInvoice.length ? (
              partialInvoice.map((row, idx) => (
                <TableRow key={`company-${idx}`}>
                  <TableCell align="left">{idx + 1}</TableCell>
                  <TableCell align="left">{row.id}</TableCell>
                  <TableCell align="left">{row.invoiceId}</TableCell>
                  <TableCell>{`${row?.member?.names} ${row?.member?.familyName}`}</TableCell>
                  <TableCell align="left">
                    {formatCurrency(row.amount)}
                  </TableCell>
                  <TableCell align="left">{row.date}</TableCell>
                  <TableCell align="left">
                    <IconButton
                      disabled
                      onClick={() => {
                        loadPrintAndShow(row);
                      }}
                    >
                      <Icon className="table_invoice">local_printshop</Icon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <p>No existe ningun registro.</p>
            )}
          </TableBody>
        </Table>
      )}
    </>
  );
}

TablePartialInvoice.propTypes = {
  loading: bool,
  providers: array,
};
